import React, { Component } from "react";

import Header from "parts/Header";
import Footer from "parts/Footer";
import AboutBanner from "parts/AboutBanner";
import AboutScode from "parts/AboutScode";
import VisionMission from "parts/VisionMission";
import WhoWeAre from "parts/WhoWeAre";
import AboutFewReason from "parts/AboutFewReason";

import { ChooseReason } from "json/landingPageData";
import { Helmet } from "react-helmet-async";

export default class AboutPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        {/* SEO  */}
        <Helmet>
          <title>Scode Software Solutions</title>
          <meta
            name="description"
            content="Learn more about Scode Software Solutions – a trusted partner in website, mobile app, and custom software development."
          />
          <link rel="canonical" href="https://www.scodesoft.com/about" />
        </Helmet>

        <Header />
        <AboutBanner />
        <AboutScode />
        <VisionMission />
        <WhoWeAre />
        <AboutFewReason data={ChooseReason} />
        <Footer />
      </>
    );
  }
}
